import {createContext} from 'react';

type ContextProps = {
    token : string | undefined
};

export const TokenContext = createContext({} as ContextProps);
